// src/utils/guardiansService.js
//
// Persistence seam for guardian ownership and selection.
//
// ===========================================================================
// NOT YET BACKED BY THE DATABASE.
//
// Every function here is a stub that succeeds locally without a network call,
// so the whole purchase/selection flow is testable today. The backend work is
// owned separately; when the endpoints exist, fill in the three functions below
// and nothing else in the app has to change - the reducer already treats these
// as the source of truth and falls back to local state when they return null.
//
// Expected shape once wired up:
//   GET  /api/guardians/:userId        -> { unlockedIds: string[], selectedId: string }
//   POST /api/guardians/purchase       -> { userId, guardianId, cost }
//   POST /api/guardians/select         -> { userId, guardianId }
// ===========================================================================

/**
 * Load the user's owned guardians and current selection.
 *
 * @param {string} userId
 * @returns {Promise<{unlockedIds: string[], selectedId: string}|null>}
 *   null means "no stored state" - the caller keeps its local defaults.
 */
export async function fetchGuardianState(userId) {
  console.log('[Guardians][Service][FetchState][Stub]', {userId});

  // TODO(backend): replace with a GET against the guardians endpoint.
  return null;
}

/**
 * Record a purchase and debit the cost from the user's QuikCoins.
 *
 * @param {{userId: string, guardianId: string, cost: number}} params
 * @returns {Promise<{success: boolean, newBalance?: number, error?: string}>}
 */
export async function purchaseGuardian({userId, guardianId, cost}) {
  console.log('[Guardians][Service][Purchase][Stub]', {userId, guardianId, cost});

  // TODO(backend): POST the purchase, let the server debit the coins and return
  // the authoritative new balance. Doing the debit server-side is what stops a
  // client from granting itself guardians for free.
  //
  // While costs are 0 there is nothing to debit, so this succeeds as-is.
  return {success: true};
}

/**
 * Record which guardian the user has equipped.
 *
 * @param {{userId: string, guardianId: string}} params
 * @returns {Promise<{success: boolean, error?: string}>}
 */
export async function saveGuardianSelection({userId, guardianId}) {
  console.log('[Guardians][Service][SaveSelection][Stub]', {userId, guardianId});

  // TODO(backend): POST the selection so it follows the user across devices.
  // Unity also mirrors it into PlayerPrefs, so a single device already
  // remembers it without this call.
  return {success: true};
}

export default {fetchGuardianState, purchaseGuardian, saveGuardianSelection};
